module.exports = __webpack_public_path__ + "static/media/app-icon.1a3f8449.jpeg";